import { Box } from '@mui/material'
import DGStackingRulesTable from '@yard/features/dg-stacking-rules/components/DGStackingRulesTable'
import DGStackingRulesTableDialog from '@yard/features/dg-stacking-rules/components/DGStackingRulesTableDialog'

const DGStackingRulesPage = () => {
  return (
    <Box>
      <DGStackingRulesTable />
      <DGStackingRulesTableDialog />
    </Box>
  )
}

export default DGStackingRulesPage
